const SignUp = () => import("../views/SignUp.vue");
const SignIn = () => import("../views/SignIn.vue");
const SignInUrl = () => import("../views/SignInUrl.vue");
const forgotPassword = () => import("../views/ForgotPassword.vue");
const forgotPasswordConfirm = () =>
  import("../views/ForgotPasswordConfirm.vue");
const changePasswordSuccess = () =>
  import("../views/ChangePasswordSuccess.vue");
const ResetPassword = () => import("../views/ResetPassword.vue");
const ConfirmSignUp = () => import("../views/ConfirmSignUp.vue");
const ChangePasswordFirstSignIn = () =>
  import("../views/ChangePasswordFirstSignIn.vue");
const Payment = () => import("../views/Payment.vue");
const Activate = () => import("../views/Activate.vue");
const ActivationSuccess = () => import("../views/ActivationSuccess.vue");

export default [
  {
    path: "/",
    name: "home",
    redirect: "/login",
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - Login to tams",
    },
  },
  {
    path: "/signup",
    name: "signup",
    component: SignUp,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - Sign up for tams",
    },
  },
  {
    path: "/signup/:payload",
    name: "signup-with-payload",
    component: SignUp,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - Sign up for tams",
    },
  },
  {
    path: "/payment",
    name: "payment",
    component: Payment,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - Make payment for tams",
    },
  },
  {
    path: "/activate/:id",
    name: "activate",
    component: Activate,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - Activate your account",
    },
  },
  {
    path: "/confirm-signup",
    name: "confirmSignUp",
    component: ConfirmSignUp,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - You have successful signed up  for tams",
    },
  },
  {
    path: "/activation-successful",
    name: "activationSuccess",
    component: ActivationSuccess,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - Your has been successfully activated",
    },
  },
  {
    path: "/company",
    name: "companyUrl",
    component: SignInUrl,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - log in to tams",
    },
  },
  {
    path: "/login",
    name: "login",
    component: SignIn,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - log in to tams",
    },
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: forgotPassword,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - Recover your password",
    },
  },
  {
    path: "/forgot-password-confirm",
    name: "forgotPasswordConfirm",
    component: forgotPasswordConfirm,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - Sign up for tams",
    },
  },
  {
    path: "/change-password-success",
    name: "changePasswordSuccess",
    component: changePasswordSuccess,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS - Sign up for tams",
    },
  },
  {
    path: "/reset-password/:reset_code",
    name: "resetPassword",
    component: ResetPassword,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS -Reset your password",
    },
  },
  {
    path: "/account-activation/:user_id/:confirmation_code",
    name: "accountActivation",
    component: ConfirmSignUp,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS -Activate your account",
    },
  },
  {
    path: "/change-password-first-signin",
    name: "changePasswordFirstSignIn",
    component: ChangePasswordFirstSignIn,
    meta: {
      subDomain: true,
      userNotAuth: true,
      title: "TAMS -Change Password on First Siginin",
    },
  },
];
